export const MENU_TABS = [
  {id: 1, title: "ЭТАПЫ СОЗДАНИЯ КАРТЫ ТЕХНОЛОГИЙ"},
  {
    id: 2,
    title: "АТРИБУТЫ ТЕХНОЛОГИЧЕСКИХ КЛАСТЕРОВ",
  },
  {
    id: 3,
    title: "АТРИБУТЫ ТЕХНОЛОГИЙ",
  },
];
